import { taskEventAttributes as taskEventAttributesDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type Attributes = {
    value: string;
    label: string;
};

type Props = {}

export const taskEventAttributes = ({}: Props): Attributes[] =>
    taskEventAttributesDiagram();
